<template>
  <div class="container">
    <div class="navigation-bar">
      <div class="navigation-bar-txt">
        <span><router-link to="/">{{ t('menu.home') }}</router-link></span>
        <span>{{ productTitle }}</span>
      </div>
    </div>
    <div class="new-list-bar">
      <h2 class="title">{{ productTitle }}</h2>
      <p class="subtitle tl">{{ productdesc }}</p>
      <h2 v-if="prefixid==='12'" class="title" style="margin-top:10px;">{{ product12Title }}</h2>
      <p  v-if="prefixid==='12'" class="subtitle tl">{{ product12desc }}</p>
      <el-carousel class="carousel-warp" height="480px" arrow="always">
        <el-carousel-item v-for="item in coreList" :key="item">
          <img :src="item.qrcode" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="new-list-bar">
      <!--1栏-->
      <h2 v-if="prefixid==='11'|| prefixid==='12'" class="title" >{{ item0title }}</h2>
      <p  v-if="prefixid==='11'|| prefixid==='12'" class="subtitle tl">{{ item0desc }}</p>
      <div class="news-list-box">
        <div class="news-list">
          <img v-if="prefixid==='11'" src="../../assets/images/cz3.png" />
          <img v-else-if="prefixid==='12'" src="../../assets/images/bl3.png" />
          <img v-else src="../../assets/images/zn2.png" />
          <div class="news-discription">
            <p class="title">{{ item1title }}</p>
            <p class="discription">{{ item1desc }}</p>
          </div>
          <ul class="ul-list">
            <li v-for="item in item1" :key="item">
              <i class="li-icon"></i><span class="span-txt">{{ item }}</span>
            </li>
          </ul>
          <div class="news-discription">
            <p class="discription">{{ item1bottom }}</p>
          </div>
        </div>
        <div class="news-list">
          <img v-if="prefixid==='11'" src="../../assets/images/cz4.png" />
          <img v-else-if="prefixid==='12'" src="../../assets/images/bl4.png" />
          <img v-else src="../../assets/images/zn3.png" />
          <div class="news-discription">
            <p class="title">{{ item2title }}</p>
            <p class="discription">{{ item2desc }}</p>
          </div>
          <ul class="ul-list">
            <li v-for="item in item2" :key="item">
              <i class="li-icon"></i><span class="span-txt">{{ item }}</span>
            </li>
          </ul>
          <div class="news-discription">
            <p class="discription">{{ item2bottom }}</p>
          </div>
        </div>
      </div>
      <!--2栏-->
      <div class="news-list-box">
        <div class="news-list">
          <img v-if="prefixid==='11'" src="../../assets/images/cz5.png" />
          <img style="border: 0px;" v-else-if="prefixid==='12'" src="" />
          <img v-else src="../../assets/images/zn4.png" />
    
          <div class="news-discription">
            <p class="title">{{ item3title }}</p>
            <p class="discription">{{ item3desc }}</p>
          </div>
          <ul class="ul-list">
            <li v-for="item in item3" :key="item">
              <i class="li-icon"></i><span class="span-txt">{{ item }}</span>
            </li>
          </ul>
          <div class="news-discription">
            <p class="discription">{{ item3bottom }}</p>
          </div>
        </div>
        <div class="news-list">
          <img v-if="prefixid==='11'" src="../../assets/images/cz6.png" />
          <img style="border: 0px;" v-else-if="prefixid==='12'" src="" />
          <img v-else src="../../assets/images/zn5.png" />
          <div class="news-discription">
            <p class="title">{{ item4title }}</p>
            <p class="discription">{{ item4desc }}</p>
          </div>
          <ul class="ul-list">
            <li v-for="item in item4" :key="item">
              <i class="li-icon"></i><span class="span-txt">{{ item }}</span>
            </li>
          </ul>
          <div class="news-discription">
            <p class="discription">{{ item4bottom }}</p>
          </div>
        </div>
      </div>
      <!--3栏-->
      <div class="news-list-box">
        <div class="news-list">
          <img v-if="prefixid==='11'" src="../../assets/images/cz7.png" />
          <img v-else-if="prefixid==='12'" src="../../assets/images/bl5.png" />
          <img v-else src="../../assets/images/zn6.png" />
          <div class="news-discription">
            <p class="title">{{ item5title }}</p>
            <p class="discription">{{ item5desc }}</p>
          </div>
          <ul class="ul-list">
            <li v-for="item in item5" :key="item">
              <i class="li-icon"></i><span class="span-txt">{{ item }}</span>
            </li>
          </ul>
          <div class="news-discription">
            <p class="discription">{{ item5bottom }}</p>
          </div>
        </div>
        <div class="news-list">
          <img v-if="prefixid==='11'" src="../../assets/images/cz8.png" />
          <img v-else-if="prefixid==='12'" src="../../assets/images/bl6.png" />
          <img style="border:0px" v-else src="" />
          <div v-if="prefixid!='13'" class="news-discription">
            <p class="title">{{ item6title }}</p>
            <p class="discription">{{ item6desc }}</p>
          </div>
          <ul  v-if="prefixid!='13'" class="ul-list">
            <li v-for="item in item6" :key="item">
              <i class="li-icon"></i><span class="span-txt">{{ item }}</span>
            </li>
          </ul>
          <div v-if="prefixid!='13'" class="news-discription">
            <p class="discription">{{ item6bottom }}</p>
          </div>
        </div>
      </div>
      <!--4栏-->
      <div class="news-list-box">
        <div class="news-list">
          <div class="foot-discription">
            <p class="title">{{ bottomTitle }}</p>
            <p class="discription">{{ bottomdesc }}</p>
            <p v-if="prefixid==='11'&& locale=='zh'" class="bm-title"> CIA- 高效智慧牧场的<span style="font-size: 40px;">耐用</span>解决方案</p>
            <p v-if="prefixid==='12' && locale=='zh'" class="bm-title"> CIA- 高效智慧牧场的<span style="font-size: 40px;">实用</span>解决方案</p>
            <p v-if="prefixid==='13'&& locale=='zh'" class="bm-title"> CIA- 高效智慧牧场的<span style="font-size: 40px;">好用</span>解决方案</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed } from "vue";
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';

const route = useRoute();
const { t,locale} = useI18n();
// 1. 核心逻辑：根据路由 ID 动态获取前缀
const prefixid = computed(() => {
  const id = route.params.id;
 
  return id;
});
const prefix = computed(() => {
  const id = route.params.id;
  if (id === "11") {
    return 'coreproduct';

  }
  if (id === "12") {
    return 'coreproduct1';
  }
  if (id === "13") {
   
    return 'coreproduct2';
  }
  return '';
});
const coreList = computed(() => {
  const id = route.params.id;
  if (id === "11") return [
  {
    qrcode: require("../../assets/images/cz1.png"),
  },
  {
    qrcode: require("../../assets/images/cz2.png"),
  }];
  if (id === "12") return [
  {
    qrcode: require("../../assets/images/bl1.png"),
  },
  {
    qrcode: require("../../assets/images/bl2.png"),
  }];
  if (id === "13") return  [
  {
    qrcode: require("../../assets/images/zn1.png"),
  }];
  return {};
});
// 2. 辅助函数：生成翻译键值
const getT = (key) => computed(() => prefix.value ? t(`${prefix.value}.${key}`) : '');
const getList = (key) => computed(() => {
  if (!prefix.value) return [];
  const str = t(`${prefix.value}.${key}`);
  return str ? str.split(';') : [];
});

// 顶部和底部通用信息
const productTitle = getT('product.item1title');
const productdesc = getT('product.item1desc');
const product12Title = getT('product.item12title');
const product12desc = getT('product.item12desc');
const bottomTitle = getT('bottom.item1title');
const bottomdesc = getT('bottom.item1desc');

// Item 1 (Product A) - 保持 item1, item1title 等变量名
const item0title = getT('productA.item0title');       // 模板用: v-for="item in item1"
const item0desc = getT('productA.item0desc');
const item1 = getList('productA.item1');       // 模板用: v-for="item in item1"
const item1title = getT('productA.item1title'); // 模板用: {{ item1title }}
const item1desc = getT('productA.item1desc');
const item1bottom = getT('productA.item1bottom');

// Item 2 (Product B)
const item2 = getList('productB.item1');
const item2title = getT('productB.item1title');
const item2desc = getT('productB.item1desc');
const item2bottom = getT('productB.item1bottom');

// Item 3 (Product C)
const item3 = getList('productC.item1');
const item3title = getT('productC.item1title');
const item3desc = getT('productC.item1desc');
const item3bottom = getT('productC.item1bottom');

// Item 4 (Product D)
const item4 = getList('productD.item1');
const item4title = getT('productD.item1title');
const item4desc = getT('productD.item1desc');
const item4bottom = getT('productD.item1bottom');

// Item 5 (Product E)
const item5 = getList('productE.item1');
const item5title = getT('productE.item1title');
const item5desc = getT('productE.item1desc');
const item5bottom = getT('productE.item1bottom');

// Item 6 (Product F)
const item6 = getList('productF.item1');
const item6title = getT('productF.item1title');
const item6desc = getT('productF.item1desc');
const item6bottom = getT('productF.item1bottom');


</script>
<style lang="scss" scoped>
.about-box {
  margin: 0 auto;
  width: 1280px;
}

.new-list-bar {
  width: 1280px;
  margin: 0 auto;
  padding-bottom: 0px;
  padding-top:30px;

  .subtitle {
    text-align: left;
  }
  .carousel-warp{
    margin-top:16px;
  }
}

.about-banner {
  width: 100%;
  position: relative;

  img {
    display: block;
    width: 100%;
  }

  p {
    width: 800px;
    position: absolute;
    text-align: center;
    left: 50%;
    margin-left: -400px;
    color: #fff;
  }

  .title {
    top: 150px;
    font-size: 50px;
  }

  .subtitle {
    top: 250px;
    font-size: 24px;
  }

  .learn-btn {
    cursor: pointer;
    top: 350px;
    width: 170px;
    height: 46px;
    font-size: 20px;
    line-height: 40px;
    position: absolute;
    text-align: center;
    left: 50%;
    border: 1px solid #fff;
    margin-left: -85px;
    color: #fff;
    border-radius: vars.$radius-4;

    &:hover {
      background-color: vars.$base-color;
      color: #fff;
      border: 1px solid vars.$base-color;
    }

    .topright-btn {
      margin-top: 10px;
    }
  }
}

.news-list-box {
  display: flex;
  justify-content: space-between;
  gap: 20px;

  .news-list {
    flex: 1;
    display: flex;
    flex-direction: column;

    .news-discription {
      font-size: 16px;

      .title {
        padding: 20px 0px 20px 0px;
        font-size: 32px;
        text-align: left;
      }

      .discription {
        padding-top: 6px;
        text-align: left;
        text-indent:30px;
      }
    }

    img {
      display: block;
      width: 625px;
      box-sizing:border-box;
      border: 2px solid #d9d9d9;
    }

    .ul-list {
      margin-top: 20px;
      display: flex;
      flex-direction: column;

      li {
        display: flex;
        flex-direction: row;
        padding: 6px 0px;

        .li-icon {
          display: block;
          width: 24px;
          height: 24px;
          background: url('../../assets/images/li-icon.svg') no-repeat left 6px;
        }

        .span-txt {
          margin-left: 10px;
          flex: 1;
          display: block;
          line-height: 32px;
          font-size: 16px;
        }
      }
    }

    .foot-discription {
      font-size: 16px;
      text-align: left;

      .title {
        padding: 20px 0px 0px 0px;
        font-size: 32px;
        text-align: left;
        font-weight: bold;
      }
      .discription{
        padding: 20px 0px 10px 0px;
      }
      .bm-title{
        padding: 10px 0px 20px 0px;
        font-size: 32px;
        text-align: left;
        font-weight: bold;
      }
    }
  }

}
</style>